@if (
  {
    violations: violations$ | async,
    countries: countries$ | async
  };
  as STATE
) {
  <article class="campaign-creation-form">
    <custom-modal-card>
      <ng-container header>
        <default-modal-header
          title="Créer un annonceur"
          description="Renseigner le champ ci-dessous pour la création d'un annonceur"
        ></default-modal-header>
      </ng-container>
      <ng-container body>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="resource-form">
          <article>
            <mat-label>Nom de l'annonceur *</mat-label>
            <mat-form-field color="primary">
              <input
                formControlName="name"
                matInput
                placeholder="Nom de l'annonceur"
              />
              <mat-error
                *ngIf="
                  $any(form.get('name'))?.getError('httpError') as httpError
                "
              >
                <strong>{{ httpError }}</strong>
              </mat-error>
            </mat-form-field>
          </article>
          <div class="input-group">
            <article>
              <mat-label>Adresse</mat-label>
              <mat-form-field color="primary">
                <input
                  formControlName="address"
                  matInput
                  placeholder="Adresse"
                />
                <mat-error
                  *ngIf="
                    $any(form.get('address'))?.getError(
                      'httpError'
                    ) as httpError
                  "
                >
                  <strong>{{ httpError }}</strong>
                </mat-error>
              </mat-form-field>
            </article>
            <article>
              <mat-label>Email</mat-label>
              <mat-form-field color="primary">
                <input
                  formControlName="email"
                  type="email"
                  matInput
                  placeholder="Email"
                />
                <mat-error
                  *ngIf="
                    $any(form.get('email'))?.getError('httpError') as httpError
                  "
                >
                  <strong>{{ httpError }}</strong>
                </mat-error>
              </mat-form-field>
            </article>
          </div>

          <div class="input-group">
            <article>
              <mat-label>Pays *</mat-label>
              <mat-form-field>
                <mat-select
                  formControlName="country"
                  placeholder="Sélectionner le pays"
                >
                  @for (country of STATE.countries; track country.code) {
                    <mat-option [value]="country.code"
                      >{{ country.name }} ({{ country.dial_code }})
                    </mat-option>
                  }
                </mat-select>
                <mat-error
                  *ngIf="
                    $any(form.get('country'))?.getError(
                      'httpError'
                    ) as httpError
                  "
                >
                  <strong>{{ httpError }}</strong>
                </mat-error>
              </mat-form-field>
            </article>
            <article>
              <mat-label>Téléphone</mat-label>
              <mat-form-field>
                <input
                  formControlName="phoneNumber"
                  matInput
                  placeholder="Téléphone"
                  type="tel"
                  #phoneNumberInput
                />
                <mat-error
                  *ngIf="
                    $any(form.get('country'))?.getError(
                      'httpError'
                    ) as httpError
                  "
                >
                  <strong>{{ httpError }}</strong>
                </mat-error>
              </mat-form-field>
            </article>
          </div>
          <article>
            <mat-label>Description</mat-label>
            <mat-form-field color="primary">
              <textarea
                formControlName="description"
                matInput
                placeholder="Description"
              ></textarea>
              <mat-error
                *ngIf="
                  $any(form.get('description'))?.getError(
                    'httpError'
                  ) as httpError
                "
              >
                <strong>{{ httpError }}</strong>
              </mat-error>
            </mat-form-field>
          </article>
          <button
            type="submit"
            [loading]="isSubmitting()"
            [disabled]="!form.valid || isSubmitting()"
            button
          >
            Enregistrer
          </button>
        </form>
      </ng-container>
    </custom-modal-card>
  </article>
}
